import developmentDomainHost from '../../components/DataProvider/domainHeader';

const root = '/issues-tracking/v1/documents';

export default async function getHelpDocuments(
  provider,
  query,
  { publicMode = false, slug, signal } = {},
) {
  const path = `${root}/${publicMode ? 'public' : 'catalog'}${slug ? `/${encodeURIComponent(slug)}` : ''}`;
  try {
    if (!publicMode) return await provider.get(path, query, { signal });
    // Public help must not use the provider's token or redirect interceptors,
    // but local builds still need the domain header the client would have added.
    const domain = developmentDomainHost();
    const response = await fetch(
      `${provider.getApiUrl()}${path}?${new URLSearchParams(query)}`,
      {
        credentials: 'omit',
        cache: 'no-store',
        signal,
        ...(domain ? { headers: { domain } } : {}),
      },
    );
    const data = await response.json();
    return response.ok
      ? { ok: true, data, errors: [] }
      : {
          ok: false,
          data: null,
          statusCode: response.status,
          errors: data?.errors?.length
            ? data.errors
            : [
                {
                  message:
                    data?.message ||
                    response.statusText ||
                    `HTTP ${response.status}`,
                },
              ],
        };
  } catch (error) {
    return { ok: false, data: null, errors: [{ message: error.message }] };
  }
}
